import { TooltipTrigger } from "@visiblethread/react-components";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";

const DEFAULT_SHIFT_OPTIONS = { padding: 8 };

const IconWithTooltip = ({
  icon,
  tooltipText,
  tooltipStyle,
  maxWidth,
  maxHeight,
  shiftOptions = DEFAULT_SHIFT_OPTIONS,
}) => {
  return (
    <TooltipTrigger
      content={parse(tooltipText)}
      tooltipStyle={tooltipStyle}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      shiftOptions={shiftOptions}
    >
      {icon}
    </TooltipTrigger>
  );
};

IconWithTooltip.propTypes = {
  icon: PropTypes.node.isRequired,
  tooltipText: PropTypes.string.isRequired,
  tooltipStyle: PropTypes.object,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  shiftOptions: PropTypes.object,
};

export default IconWithTooltip;
